import type { Question } from "../../../lib/types";
import { bandOf, type CompareModel } from "../../../lib/stageViewModels";
import { CompareUnavailable } from "./CompareBars";
import { ScrollCenter } from "./McqBars";
import { useGrowIn } from "./useGrowIn";

export function CompareSentiment({ compare, question, loading }: { compare: CompareModel; question: Question; loading: boolean }) {
  const { grown, reduced } = useGrowIn();
  if (!compare.available) return <CompareUnavailable loading={loading} />;
  const isNps = question.question_type === "nps";
  const labels = isNps ? ["Detraktoren", "Passiv", "Promotoren"] : ["Kritisch", "Mitte", "Zustimmend"];
  return (
    <ScrollCenter className="gap-8 text-rc-paper">
      {compare.segments.map((s) => {
        const bands = { low: 0, mid: 0, high: 0 };
        for (const [value, n] of Object.entries(s.values)) bands[bandOf(question, Number(value))] += n;
        const total = bands.low + bands.mid + bands.high;
        const pct = (n: number) => (total === 0 ? 0 : Math.round((n / total) * 100));
        return (
          <section key={s.key} className="flex flex-col gap-2">
            <header className="flex items-baseline justify-between">
              <span className="font-semibold" style={{ fontSize: "clamp(1rem, 1.5vw, 1.5rem)" }}>{s.label}</span>
              <span className="text-[12px] text-rc-paper/50 tabular-nums">{s.respondents} Befragte</span>
            </header>
            <div className={`flex items-stretch gap-1 h-12 rounded-rc-lg overflow-hidden ${reduced ? "" : "transition-opacity duration-700"}`} style={{ opacity: grown ? 1 : 0 }}>
              {[{ n: bands.low, cls: "bg-rc-paper/15 text-rc-paper/80" }, { n: bands.mid, cls: "bg-rc-paper/35" }, { n: bands.high, cls: "bg-rc-berry" }]
                .filter((b) => b.n > 0)
                .map((b, i) => (
                  <div key={i} style={{ flex: b.n }} className={`min-w-[2.5rem] flex items-center justify-center text-[13px] font-semibold tabular-nums ${b.cls}`}>{pct(b.n)}%</div>
                ))}
            </div>
          </section>
        );
      })}
      <div className="grid grid-cols-3 text-[11px] font-bold uppercase tracking-[0.22em] text-rc-paper/55">
        <span>{labels[0]}</span><span className="text-center">{labels[1]}</span><span className="text-right">{labels[2]}</span>
      </div>
    </ScrollCenter>
  );
}
